import React, { useEffect, useState } from "react";
import styles from "./createRole.module.css";
import { DropDown, Input } from "../../Common";
import {
  signUpDashboard,
  getnewFeatureList,
  getCustomerRoles,
  getUsersPartnerList,
} from "../../api";
import Button from "../../Common/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import FeatureAccess from "../AddRole/featureAcess";
import { validateForm } from "../../utils/validation";
import { Spinner } from "react-bootstrap";
import withFeatureActions from "../../withFeatureActions";
import { productType } from "../../utils/utils";
const CreateRole = ({ featureAccess }) => {
  const initialFormData = {
    name: "",
    username: "",
    partner: "",
    roles: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [featureList, setFeatureList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [errors, setErrors] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [showCanvas, setShowCanvas] = useState(false);
  const [partnerList, setPartnerList] = useState([]);
  const [accessState, setAccessState] = useState({});
  const [loading, setLoading] = useState(false);
  const [confirmedAccess, setConfirmedAccess] = useState({});

  let custom = "CUSTOM_ROLE";

  useEffect(() => {
    if (formData.roles === custom) {
      setLoader(true);
      setShowCanvas(true);
      fetchNewFeatureList();
    } else {
      setFeatureList([]);
      setAccessState({});
      setShowCanvas(false);
    }
  }, [formData.roles]);

  const fetchNewFeatureList = async () => {
  setLoading(true);
  try {
    const res = await getnewFeatureList();
    if (res?.data?.code === 200) {
      const featureData = res.data.data;
      setFeatureList(featureData);

      const initializedAccess = {};
      featureData.forEach(({ source, featureList }) => {
        if (!initializedAccess[source]) initializedAccess[source] = {};
        featureList.forEach((parent) => {
          const parentKey = parent.parentFeature;
          initializedAccess[source][parentKey] = {
            actions: { read: false, write: false, modify: false },
            children: {},
          };
          parent.subFeatures?.forEach((sub) => {
            initializedAccess[source][parentKey].children[sub.componentName] = {
              read: false,
              write: false,
              modify: false,
            };
          });
        });
      });

      setAccessState(initializedAccess);
    } else {
      setErrors({ submit: "Error loading features" });
    }
  } catch {
    setErrors({ submit: "Failed to fetch feature list" });
  } finally {
    setLoading(false);
    setLoader(false);
  }
};
  const fetchPartnerList = () => {
    getUsersPartnerList({ appName: productType.ALL })
      .then((response) => {
        if (response?.data?.code === 200) {
          const partners = response?.data?.data.map((partner) => ({
            name: partner.partnerName,
            code: partner.partnerCd,
          }));
          setPartnerList(partners);
        }
      })
      .catch((error) => {
        setErrors({
          submit:
            error?.response?.data?.message || "Failed to fetch partner list",
        });
      });
  };

  useEffect(() => {
    fetchPartnerList();
  }, []);

  useEffect(() => {
    if (formData.partner) {
      setFormData((prev) => ({ ...prev, roles: "" }));
      customerRoles();
    }
  }, [formData.partner]);

  const customerRoles = () => {
    getCustomerRoles().then((resp) => {
      if (resp.data.code === 200) {
        const roleData = resp.data.data.data;
        const partnerCode = formData?.partner?.code || "";
        const result = [];

        Object.values(roleData).forEach((rolesArray) => {
          const role = rolesArray[0];
          if (role.role_title) {
            const isAdminRole = role.role_title.toLowerCase() === "admin";
            const isStockal = partnerCode === "STOCKAL";

            if (!isAdminRole || (isAdminRole && isStockal)) {
              result.push(role);
            }
          }
        });

        result.push({ role_title: custom, dashboard_role_id: custom });
        setRoleList(result);
      }
    });
  };

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: name === "username" ? value.toLowerCase() : value, }));

    if (name === "username") {
      if (!validateEmail(value.toLowerCase())) {
        setErrors((prev) => ({
          ...prev,
          username: "Please enter a valid email address.",
        }));
      } else {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors.username;
          return newErrors;
        });
      }
    }
  };

  const flattenAccess = (access) => {
    const result = [];
    featureList?.forEach(({ source, featureList: parents }) => {
      parents?.forEach((parent) => {
        const parentAccess = access?.[source]?.[parent.parentFeature];
        if (parentAccess?.actions) {
          const parentFeatureId =
            parent.parentFeatureId || parent.dashboardFeatureId;
          const parentFeature = {
            featureId: parseInt(parentFeatureId),
            isRead: !!parentAccess.actions.read,
            isWrite: !!parentAccess.actions.write,
            isModify: !!parentAccess.actions.modify,
          };
          if (
            parentFeature.isRead ||
            parentFeature.isWrite ||
            parentFeature.isModify
          ) {
            result.push(parentFeature);
          }
          parent.subFeatures?.forEach((sub) => {
            const subAccess = parentAccess.children?.[sub.componentName] || {};
            const subFeature = {
              featureId: parseInt(sub.dashboardFeatureId),
              isRead: !!subAccess.read,
              isWrite: !!subAccess.write,
              isModify: !!subAccess.modify,
            };
            if (
              subFeature.isRead ||
              subFeature.isWrite ||
              subFeature.isModify
            ) {
              result.push(subFeature);
            }
          });
        }
      });
    });
    return result;
  };

  const createDashboardUser = async (e) => {
    e.preventDefault();
    setLoader(true);
    setErrors({});

    const requiredFields = ["name", "username", "partner", "roles"];
    if (!validateForm(requiredFields, setErrors, formData)) {
      setLoader(false);
      return;
    }

    if (!validateEmail(formData.username)) {
      setErrors((prev) => ({
        ...prev,
        username: "Please enter a valid email address.",
      }));
      setLoader(false);
      return;
    }

    let data = {};
    if (formData.roles === custom) {
      const featuresArray = flattenAccess(confirmedAccess);
      if (featuresArray.length === 0) {
        setErrors({
          submit: "Please select at least one feature for custom role",
        });
        setLoader(false);
        return;
      }
      data = {
        name: formData.name,
        emailId: formData.username.toLowerCase(),
        code: formData.partner.code,
        roleId: custom,
        features: featuresArray,
      };
    } else {
      const selectedRole = roleList.find(
        (role) => role.role_title === formData.roles
      );
      data = {
        name: formData.name,
        emailId: formData.username.toLowerCase(),
        code: formData.partner.code,
        roleId: selectedRole?.dashboard_role_id || formData.roles,
      };
    }

    try {
      const response = await signUpDashboard(data);
      if (response?.data?.code === 200) {
        setSuccessMessage("Account created successfully!");
        setTimeout(() => {
          setSuccessMessage("");
          setFormData(initialFormData);
          setAccessState({});
          setShowCanvas(false);
        }, 3000);
      } else {
        setErrors({
          submit: response?.data?.message || "Something went wrong",
        });
      }
    } catch (err) {
      setErrors({
        submit: err?.response?.data?.message || "Failed to create account",
      });
    }
    setLoader(false);
  };

  return (
    <>
      <div className={styles.containerCardRoles}>
        <div className={styles.createRoleCard}>
          <div className={styles.card}>
            {featureAccess?.writeAccess ? (
              <>
                <h3>
                  Create User at{" "}
                  <span style={{ color: "#0061d3" }}>Borderless</span>
                </h3>
                <form onSubmit={createDashboardUser}>
                  <Input
                    label="Name"
                    name="name"
                    placeholder="Enter Name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    error={!!errors.name}
                    helperText={errors.name}
                  />

                  <Input
                    label="Email"
                    name="username"
                    placeholder="Enter Email"
                    required
                    value={formData.username}
                    onChange={handleChange}
                    error={!!errors.username}
                    helperText={errors.username}
                  />

                  <DropDown
                    label="Partner"
                    name="partner"
                    required
                    value={formData.partner?.code}
                    placeholder="Select Partner"
                    data={partnerList.map((partner) => ({
                      label: partner.name,
                      value: partner.code,
                    }))}
                    onChange={(value) => {
                      const selected = partnerList.find(
                        (p) => p.code === value
                      );
                      setFormData((prev) => ({ ...prev, partner: selected }));
                    }}
                    error={!!errors.partner}
                    helperText={errors.partner}
                  />

                  <DropDown
                    label="Roles"
                    name="roles"
                    required
                    value={formData.roles}
                    placeholder="Select Roles"
                    data={roleList.map((role) => ({
                      label: role.role_title,
                      value: role.role_title,
                    }))}
                    onChange={(value) => {
                      setFormData((prev) => ({ ...prev, roles: value }));
                      if (value !== custom) {
                        setAccessState({});
                        setConfirmedAccess({});
                      }
                    }}
                    error={!!errors.roles}
                    helperText={errors.roles}
                  />
                </form>
                {successMessage ? (
                  <p style={{ color: "green", marginTop: "15px" }}>
                    {successMessage}
                  </p>
                ) : (
                  <p style={{ color: "red", marginTop: "15px" }}>
                    {errors.submit}
                  </p>
                )}
                <div style={{ width: "160px" }}>
                  <Button
                    onClick={createDashboardUser}
                    title={"Create User"}
                    loading={loader}
                  />
                </div>
              </>
            ) : (
              <div className={styles.errorMessage}>
                You do not have access to create Users.
              </div>
            )}
          </div>
        </div>
      </div>
      <Offcanvas
        show={showCanvas}
        onHide={() => {
          setShowCanvas(false);
          setFormData((prev) => ({ ...prev, roles: "" }));
          setAccessState({});
        }}
        placement="end"
        className={styles.offcanvas}
        style={{ color: "white" }}
      >
        <Offcanvas.Header
          closeButton
          style={{
            backgroundColor: "#343434",
            color: "white",
            fontSize: "15px",
            height: "50px",
          }}
        >
          <Offcanvas.Title>Select Role Features</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body style={{ paddingBottom: "80px", maxHeight:"572px" }}>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <Spinner animation="border" className={styles.spinnerColor} />
            </div>
          ) : (
            <FeatureAccess
              data={featureList}
              accessState={accessState}
              setAccessState={setAccessState}
            />
          )}
        </Offcanvas.Body>
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            padding: "16px",
          }}
        >
          <Button
            title="Confirm Features"
            onClick={() => {
              setConfirmedAccess(accessState);
              setShowCanvas(false);
            }}
          />
        </div>
      </Offcanvas>
    </>
  );
};

export default withFeatureActions(CreateRole, "ADMIN", "Create User");
